import LiquidityHoldings from "./liquidity-holdings";

export default LiquidityHoldings;

